import { RECORDS_PER_PAGE } from "@constants";
import { i18n } from "@translations/i18n";
import { EMeasuringUnit, IUsage } from "./interface/IUsage";
import { IUsageSummary } from "./interface/IUsageSummary";
import { ECarouselType } from "./UsageCarousel/ECarouselType";

export const getFormattedQueryFromState = (currentPage: number, selectedType?: string, pageSize?: number) => {
    let query = `?page=${currentPage}`;

    if (selectedType && selectedType !== i18n.t("usage:all")) {
        query += `&usageTypes=${selectedType}`;
    }

    if (pageSize && pageSize !== RECORDS_PER_PAGE[0]) {
        query += `&size=${pageSize}`;
    }

    return query;
};

const formatTimeUsage = (duration: number) => {
    const hours = Math.floor(duration / 3600)
        .toString()
        .padStart(2, "0");
    const minutes = (Math.floor(duration / 60) % 60).toString().padStart(2, "0");
    const seconds = Math.floor(duration % 60)
        .toString()
        .padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
};

export const formatUsage = (usage: IUsage): number | string => {
    switch (usage.measuringUnit) {
        case EMeasuringUnit.SECOND:
            return formatTimeUsage(usage.quantity);
        case EMeasuringUnit.B:
            return `${(usage.quantity / 1073741824).toFixed(3)}GB`;
        case EMeasuringUnit.EVENT:
            return usage.quantity;
        default:
            return usage.quantity;
    }
};

export const sliceUsageForMobileCarrousel = (usageSummaryList: IUsageSummary[], elementsPerRow: number) => {
    let slicedUsageList = [usageSummaryList.slice(0, elementsPerRow)];

    for (let i = elementsPerRow; i < usageSummaryList.length; i += elementsPerRow) {
        slicedUsageList = [...slicedUsageList, usageSummaryList.slice(i, i + elementsPerRow)];
    }

    return slicedUsageList;
};

export const CAROUSEL_CONFIG = {
    [ECarouselType.MOBILE]: {
        ELEMENTS_TO_SHOW: 1,
        USAGE_PER_SLIDE: 4,
    },
    [ECarouselType.DESKTOP]: {
        ELEMENTS_TO_SHOW: 4,
        USAGE_PER_SLIDE: 1,
    },
};
